import { Mutation } from "@evergis/react-fetching/es/createMutation";
import { SetLayerParameterValueParams } from "@evergis/api";

import { getEqlParam, setEqlParam } from "../../resources/eql";

import { LayerInfo } from "../../interfaces/resourceInfo";

type SetParamMutation = Mutation<SetLayerParameterValueParams, { result: void; layerName: string }>;

export const useLayerParam = (layer?: LayerInfo, paramName?: string): [string, SetParamMutation] => {
  const { data: layerParam } = getEqlParam.use({
    input: layer?.type === "QueryLayerService" && paramName ? { layerName: layer.name, paramName } : undefined,
    waitInput: true,
  });

  const [setLayerParam] = setEqlParam.use();

  return [layerParam, setLayerParam];
};
